import { EntityDialog, AddBtn, IconBtn } from "@/components/admin/shared";
import { Pencil, Trash2 } from "lucide-react";

export default function RacesPanel({ races, raceFields, saveRace, del, setRaces }) {
  const sorted = [...races].sort((a, b) => String(a.date || "").localeCompare(String(b.date || "")));
  return (
    <>
      <div className="flex justify-end mb-4">
        <EntityDialog title="Nuova gara" fields={raceFields} initial={{ category: "Slalom", status: "In programma" }} onSave={saveRace} trigger={<AddBtn data-testid="add-race-btn" />} />
      </div>
      <div className="space-y-2">
        {sorted.map((r) => (
          <div key={r.id} className="flex items-center gap-3 p-3 rounded-sm border border-slate-200 dark:border-slate-800 bg-white dark:bg-legend-paper">
            <div className="flex-1"><p className="font-display font-bold uppercase text-sm">{r.name}</p><p className="text-xs text-slate-500">{r.location} · {r.date} · {r.category}</p></div>
            <EntityDialog title="Modifica gara" fields={raceFields} initial={{ ...r, orari_text: (r.orari || []).join("\n") }} onSave={saveRace} trigger={<IconBtn data-testid={`edit-race-${r.id}`}><Pencil size={15} /></IconBtn>} />
            <IconBtn data-testid={`delete-race-${r.id}`} onClick={() => del("/admin/races", r.id, setRaces, races)}><Trash2 size={15} /></IconBtn>
          </div>
        ))}
      </div>
    </>
  );
}
